import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import RMSTheme from "../../../themes/RMSTheme";

import Dashboard from "./Dashboard";
import Appraisal from "./Appraisal/Appraisal";
import AppraisalList from "./Appraisal/AppraisalList";
import Appraisee from "./Appraisee/Appraisee";
import AppraiseeList from "./Appraisee/AppraiseeList";

const AppraisalRouter = () => (
    <ThemeProvider theme={RMSTheme}>
        <Switch>
            <Route
                path="/rms/appraisals/:id/:appraiseeUUID?"
                component={Appraisal}
            />
            <Route path="/rms/appraisals/" component={AppraisalList} />
            <Route path="/rms/appraisees/:uuid" component={Appraisee} />
            <Route path="/rms/appraisees/" component={AppraiseeList} />
            <Route path="/rms/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default AppraisalRouter;
